import React from 'react';

import AddNote from 'actions/composer/add_note';
import Composer, { Header, HeaderText, useComposer } from './shared/composer';
import { EditorContainer, useEditor } from './shared/editor';
import { AttachmentStyles, RichTextEditorStyles, EmojiStyles } from './shared/editor_styles';
import RichTextEditor from './editors/rich_text';

export function NoteComposer() {
  const composer = useComposer(AddNote);
  const editorProps = useEditor('bodyHtml', composer);
  const [composerProps] = composer;

  return (
    <Composer includeAttachments submitText="Add Note" {...composerProps}>
      <Header>
        <HeaderText color="yellow400">Note</HeaderText>
        <RichTextEditorStyles {...editorProps}>
          <EmojiStyles {...editorProps} />
          <AttachmentStyles alwaysShow />
        </RichTextEditorStyles>
      </Header>
      <EditorContainer includeAttachments>
        <RichTextEditor placeholder="Type to enter note" {...editorProps} />
      </EditorContainer>
    </Composer>
  );
}

export default React.memo(NoteComposer);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/note_composer.jsx